import axios, { AxiosResponse } from 'axios';

import { EStavPozadavku } from 'enums/specialniSluzby/stavPozadavku';
import { ETypTransakce } from 'enums/specialniSluzby/typTransakce';

type DateTimeString = string;

export interface IPozadavkyPolozkaDVP {
    idpolozky: number;
    pocetcp: number;
    castka: number;
    kodklienta: string;
    koducastnika: string;
    zdrojdat: string;
    zpusobporizeni: string;
    typtransakce: ETypTransakce;
    upozorneni: string;
    idvcdcp: string;
    stav: string;
    idvisb: string;
    uzivatel: string;
    meznidatumprozruseni: DateTimeString;
    lzeevidovatod: DateTimeString;
    sparovano?: boolean;
}

export interface IPozadavkyDVP {
    id: number;
    castka: number;
    cenacp: number;
    celkpoccp: number;
    pocetuctu: number;
    castkacelkem: number;
    upisovatelucelkem: number;
    celkpocupis: number;
    celkcastka: number;
    pocetcp: number;
    mena: string;
    polozky: IPozadavkyPolozkaDVP[];
    count: number;
    order: string;
    limit: number;
    offset: number;
    iban?: string;
    bankucet?: string;
    bicprij?: string;
    bic?: string;
    nazprij?: string;
    adrprij1?: string;
    adrprij2?: string;
    adrprij3?: string;
    pocetcpvn?: number;
    vnresult?: boolean;
}

export interface IFilterDVP {
    id?: number;
    idpolozky?: number;
    koducastnika?: string;
    kodklienta?: string;
    zdrojdat?: string;
    idvcdcp?: string;
    typtransakce?: ETypTransakce;
    stav?: EStavPozadavku;
    offset?: number;
    limit?: number;
    order: string;
    evidovat?: boolean; // len pre zaevidovani
}

/* Vrátí detail zvoleného požadavku s položkami */
const uePozadavkyDetailDVPApi = (id: number, data: IFilterDVP) => {
    return axios({
        method: 'GET',
        url: `/UEV/${id}/pozadavky`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IPozadavkyDVP>) => resp.data);
};

export interface IVymazaniPolozkaDVP {
    idpolozky: number;
    pocetcp: number;
    kodklienta: string;
    koducastnika: string;
    poznamka: string;
    zdrojdat: string;
    zpusobporizeni: string;
    typtransakce: ETypTransakce;
    upozorneni: string;
    idvcdcp: string;
    stav: string;
    uzivatel: string;
    castka: number;
}

export interface IVymazaniDataDVP {
    polozky: IVymazaniPolozkaDVP[];
    count: number;
    order: string;
    limit: number;
    offset: number;
    pocetcp: number;
    castka: number;
    upisovatelu: boolean;
}

export const uePozadavkyZmazaniDVPApi = (id: number, data: IFilterDVP) => {
    return axios({
        method: 'GET',
        url: `/UEV/${id}/vymazani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IPozadavkyDVP>) => resp.data);
};

export const ueZmazaniDeleteDVP = (id: number, data?: IZaevidovaniDVPpost) => {
    return axios({
        method: 'DELETE',
        url: `/UEV/${id}/vymazani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse) => resp.data);
};

export const ueZaevidovaniDVP = (id: number, data?: IFilterDVP) => {
    return axios({
        method: 'GET',
        url: `/UEV/${id}/zaevidovani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IPozadavkyDVP>) => resp.data);
};

export interface IZaevidovaniDVPpost {
    idpolozky?: number;
    kodklienta?: string;
    koducastnika?: string;
    typtransakce?: ETypTransakce;
    stav?: string;
    zdrojdat?: string;
    idvcdcp?: string;
}

export const ueZaevidovaniPostDVP = (id: number, data: IZaevidovaniDVPpost) => {
    return axios({
        method: 'POST',
        url: `/UEV/${id}/zaevidovani`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse) => resp.data);
};

export interface IDataZalozeniPozadavekDVP {
    idpolozky: number;
    pocetcp: number;
    castka: number;
    kodklienta: string;
    koducastnika: string;
    zpusobporizeni: string;
    typtransakce: ETypTransakce;
}

/* Založení nebo update položky požadavku (při ručním zadávání po jedné položce) */
export const ueZalozeniPozadavekDVP = (id: number, data: IDataZalozeniPozadavekDVP) => {
    return axios({
        method: 'POST',
        url: `/UEV/${id}/zalozeni`,
        data: data
    }).then(resp => resp.data);
};

export const ueZruseniSingleDVP = (id: number) => {
    return axios({
        method: 'PUT',
        url: `/UEV/${id}/zruseni`
    }).then((resp: AxiosResponse) => resp.data);
};

export default uePozadavkyDetailDVPApi;
